import * as EventListener from "./helpers/event-listener";

const clickQuestions = () => {
    EventListener.click("question", (element) => {
        const showClass = "show";

        element.parentNode.classList.contains(showClass)
            ? element.parentNode.classList.remove(showClass)
            : element.parentNode.classList.add(showClass);
    });
};

const closeFilterOnBackDropClick = () => {
    const dialogElement = document.getElementById("faqFilter");

    dialogElement &&
        dialogElement.addEventListener("click", (event) => {
            if (event.target === dialogElement) {
                dialogElement.close();
            }
        });
};

// const clickFilter = () => {
//     EventListener.click("faq-filter-item", (button) => {
//         const filterId = button.getAttribute("data-filter-id");
//         faqFilter.close();
//         button.disabled = false;
//     });
// };

clickQuestions();
closeFilterOnBackDropClick();
// clickFilter();
